export enum ETipoConta {
  Cofre = 1,
  CaixaDiario = 2,
  ContaCorrente = 3,
  ContaPoupanca = 4,
  Cartao = 5,
  Investimento = 6,
  Outros = 7,
}
